module.exports = __webpack_public_path__ + "static/media/OOE.ac8d387b.svg";